define({
    MAIN_VEHICLE_NUMBER: 1,
    ADDITIONAL_VEHICLE_NUMBER: 2,
});




// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/constants/MFPVehicleConstants.js